// extracted by mini-css-extract-plugin
export var sectionintro = "SectionIntro-module--sectionintro--y0lqf";
export var sectionintroCenter = "SectionIntro-module--sectionintro--center--mXzgQ";
export var sectionintroLeft = "SectionIntro-module--sectionintro--left--3iZHD";
export var sectionintroRight = "SectionIntro-module--sectionintro--right--oobtK";
export var fadeOutAnimation = "SectionIntro-module--fadeOutAnimation--2cDVt";
export var fadeInAnimation = "SectionIntro-module--fadeInAnimation--3tH20";